import React from "react";
import Loader from "components/Loader";
import Top from "components/Top";
import Modal from "components/Modal";
import * as API from "lib/apis";
import * as C from "../../constants";
import { BuyInfo, BuyInput, BuySearchResult } from "pages";
import { numberWithCommas, isEmpty } from "lib/utils";
import { useLocalStorage } from "lib/useLocalStorage";

export default class Buy extends React.Component {
  state = {
    type: "",
    isLoading: false,
    buyPoint: "",
    minutes: 1,
    seconds: 0,
    modalVisible: false,
    // api data
    currentPrice: {},
    userOcbPoint: {}, // 현재 사용 가능한 ocb point
    prepareBuy: {
      estimateTrade: {},
    }, // 매수 전 조회 정보
    buyResult: {},
    name: "",
    display: C.Message.display["SYRUP"],
  };

  timer = {
    start: () => {
      clearInterval(this.myInterval);

      this.setState({ minutes: 1, seconds: 0 }, () => {
        this.myInterval = setInterval(() => {
          const { seconds, minutes } = this.state;
          if (seconds > 0) {
            this.setState(({ seconds }) => ({
              seconds: seconds - 1,
            }));
          }
          if (seconds === 0) {
            if (minutes === 0) {
              clearInterval(this.myInterval);
              // 재검색
              this.buyPointSearch();
            } else {
              this.setState(({ minutes }) => ({
                minutes: minutes - 1,
                seconds: 59,
              }));
            }
          }
        }, 1000);
      });
    },
    stop: () => {},
  };

  constructor(props) {
    super(props);
    this.callBackUrl = this.callBackUrl.bind(this);
    window.buy = this;
  }

  callBackUrl() {
    this.props.history.push({
      pathname: "/main",
      search: `?name=${this.state.name}&serviceCode=${this.props.serviceCode}`,
    });
  }

  componentDidMount() {
    if (this.props.serviceCode === "SYRUP") {
      window.wallet.setPageConfig(
        '{"pageType":"MEMBERSHIP", "backJS":"buy.callBackUrl"}'
      );
      window.wallet.setTitle('{"title":"비단 금투자 서비스"}');
    }
  }

  componentWillMount = async () => {
    const reqParamObj = new URLSearchParams(this.props.location.search);
    const type = reqParamObj.get("type");
    const name = reqParamObj.get("name");
    const serviceCode = reqParamObj.get("serviceCode");
    const display = C.Message.display[serviceCode];
    if (!type && window.wallet && serviceCode === "SYRUP") {
      window.wallet.finish(); // 비단 앱 종료
    }

    this.setState({
      isLoading: true,
      display: display,
      type,
      name,
    });

    const apiPrice = API.getCurrentPrice(({ data }) => {
      this.setState((state) => ({
        ...state,
        currentPrice: data,
      }));
    });

    const apiUserOcbPoint = API.getOcbPoint(({ data }) => {
      this.setState((state) => ({
        ...state,
        userOcbPoint: data,
      }));
    });

    Promise.all([apiPrice, apiUserOcbPoint]).then(() => {
      this.setState({ isLoading: false });
    });
  };

  checkValidation = () => {
    const { serviceCode } = this.props;
    const { buyPoint, userOcbPoint } = this.state;
    const { ocbPoint } = userOcbPoint;
    const display = C.Message.display[serviceCode];

    if (+buyPoint < display.minAmount) {
      alert(
        `매수 가능 ${display.amount}는 ${display.minAmount}${display.unit} 부터 사용 가능합니다.`
      );
      return false;
    }

    if (+buyPoint > 500000) {
      alert(
        `매수 가능 ${display.amount}은 50만${display.unit}까지 사용 가능합니다.`
      );
      return false;
    }

    if (+buyPoint > +ocbPoint) {
      alert(`보유하신 ${display.amount}보다 많이 사용하실 수 없습니다.`);
      return false;
    }
    return true;
  };

  buyPointSearch = () => {
    if (this.checkValidation()) {
      this.setState({ isLoading: true });
      API.getPrepareBuy(this.state.type, this.state.buyPoint, (res) => {
        const { businessTime, errorMessage, success, data } = res;
        if (!businessTime) {
          alert(errorMessage);
          this.setState({
            isLoading: false,
            prepareBuy: { estimateTrade: {} },
          });
          this.timer.stop();
          return false;
        }
        if (!success) {
          alert(errorMessage);
          this.setState({
            isLoading: false,
            prepareBuy: { estimateTrade: {} },
          });
          this.timer.stop();
          return false;
        }
        this.setState(
          (state) => ({
            ...state,
            prepareBuy: data,
            isLoading: false,
          }),
          () => {
            this.timer.start();
          }
        );
      });
    }
  };

  handleClickMaxPoint = () => {
    const { userOcbPoint } = this.state;
    const { ocbPoint } = userOcbPoint;
    this.setState({ buyPoint: Math.min(+ocbPoint, 500000) });
  };

  handleChangeBuyPoint = ({ target: { value } }) => {
    const unComma = value.replace(/,/gi, "");
    const regexp = /^[0-9\b]+$/;
    if (unComma === "" || regexp.test(unComma)) {
      this.setState({ buyPoint: unComma });
    }
  };

  reqBuyPoint = () => {
    this.setState({ isLoading: true });
    API.reqBuyPoint(this.state.prepareBuy.id, (res) => {
      const { success, data, errorMessage } = res;
      if (success) {
        setTimeout(() => {
          this.setState(
            (state) => ({
              ...state,
              buyResult: data,
              isLoading: false,
            }),
            () => {
              this.setState({ modalVisible: true });
            }
          );
        }, 100);
      } else {
        alert(errorMessage);
        this.setState((state) => ({
          ...state,
          buyResult: {},
          isLoading: false,
        }));
      }
    });
  };

  closeModal = () => {
    this.setState({ modalVisible: false, isLoading: true }, () => {
      setTimeout(() => {
        this.callBackUrl();
      }, 500);
    });
  };

  render() {
    const { serviceCode } = this.props;
    const { minutes, seconds, modalVisible } = this.state;

    const {
      // ui variable
      type,
      buyPoint,
      isLoading,
      // api data
      currentPrice,
      userOcbPoint,
      prepareBuy: { estimateTrade },
      buyResult,
      display,
    } = this.state;

    let modalTit = "e금";
    if (type === "pes") {
      modalTit = "e은";
    }
    let topClassName = "top_name";
    if (serviceCode === "MONEYTREE") {
      topClassName = "top_name product_moneytree";
    }
    return (
      <>
        {isLoading && <Loader />}
        <BuyModal
          visible={modalVisible}
          onClose={this.closeModal}
          param={{
            price: buyResult.price,
            amount: buyResult.amount,
            fee: buyResult.fee,
            totalPrice: buyResult.totalPrice,
            modalTit: modalTit,
          }}
        />
        <Top history={this.props.history} />

        <div
          className={`wrap sale_con ${
            serviceCode === C.SERVICE_CODE.OKINV ? "ok_wrap" : ""
          }`}
        >
          <BuyInfo type={type} currentPrice={currentPrice} />

          <div
            className={`content ${
              serviceCode === C.SERVICE_CODE.OKINV ? "ok_wrap" : ""
            }`}
          >
            <div className={topClassName}>
              <span className="left">{display?.buyCash}</span>
              <span className="right">
                <span
                  style={{
                    width: "70%",
                    display: "inline-block",
                    wordBreak: "break-all",
                  }}
                >
                  {numberWithCommas(userOcbPoint.ocbPoint)}
                </span>
                <div>{display?.unit}</div>
              </span>
            </div>

            <div className="tab_box">
              <div id="container">
                <div id="tab1" className="tabcontent current">
                  <BuyInput
                    buyPoint={buyPoint}
                    estimateTrade={estimateTrade}
                    handleClickMaxPoint={this.handleClickMaxPoint}
                    handleChangeBuyPoint={this.handleChangeBuyPoint}
                    buyPointSearch={this.buyPointSearch}
                  />

                  <BuySearchResult
                    type={type}
                    estimateTrade={estimateTrade}
                    buyPointSearch={this.buyPointSearch}
                    minutes={minutes}
                    seconds={seconds}
                  />
                </div>
              </div>
            </div>
            {!isEmpty(estimateTrade) && (
              <div className="btn_area MT30 apply_btn">
                <div className="bt_col1">
                  <input
                    type="button"
                    value="매수"
                    className="blue pop"
                    onClick={this.reqBuyPoint}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

const VatText = {
  color: "#999",
  fontSize: "11px",
  display: "inline",
};

const BuyModal = ({
  visible,
  onClose,
  param: { modalTit, price, amount, fee, totalPrice },
}) => {
  const [serviceCode] = useLocalStorage(C.STORAGE_KEY.SERVICE_CODE);
  return (
    visible && (
      <Modal visible={visible} onClose={onClose}>
        <div className="apply_form">
          <div
            className={`scroll_wrap ${
              serviceCode === C.SERVICE_CODE.OKINV ? "ok_wrap" : ""
            }`}
          >
            <div className="form_wrap sale_wrap">
              <h3 className="TXC F18">{modalTit} 매수확인</h3>
              <div className="buy_wrap2">
                <ul className="pay_list">
                  <li>
                    <span className="left">단가</span>
                    <span className="right">
                      <em>{numberWithCommas(price)}</em>
                      <span className="right3"> KRW</span>
                    </span>
                  </li>
                  <li>
                    <span className="left">수량</span>
                    <span className="right">
                      <em>{numberWithCommas(amount)}</em>
                      <span className="right3"> g</span>
                    </span>
                  </li>
                  <li>
                    <span className="left">
                      수수료 <p style={VatText}>(VAT 포함)</p>
                    </span>
                    <span className="right">
                      <em>{numberWithCommas(fee)}</em>
                      <span className="right3">
                        {" "}
                        {C.Message.display[serviceCode].unit}
                      </span>
                    </span>
                  </li>
                  <li>
                    <span className="left">
                      매수 {C.Message.display[serviceCode].amount}
                    </span>
                    <span className="right">
                      <em>{numberWithCommas(totalPrice - fee)}</em>
                      <span className="right3">
                        {" "}
                        {C.Message.display[serviceCode].unit}
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
              <div className="PB40">
                <span className="left2">
                  총 사용 {C.Message.display[serviceCode].amount}
                </span>
                <span className="right2">
                  <em className="blue2">{numberWithCommas(totalPrice)}</em>
                  <span className="right4">
                    {" "}
                    {C.Message.display[serviceCode].unit}
                  </span>
                </span>
              </div>
              <div className="btn_area  col_1">
                <span className="btn_mem blue" onClick={onClose}>
                  확인
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  );
};
